module.exports = __webpack_public_path__ + "img/wait.2b797d4b.png";